import React, {useState,useEffect} from 'react'
import downArrow from "../images/orgarrow.svg";
import { useNavigate } from "react-router-dom";
import arrow from '../images/thinArrow.png'
import checkmarkGreen from '../images/checkmark-green.png';
import checkmarkRed from '../images/checkmark-red.png'
import calendar from '../images/Icon-Calendar.png'

function SentNewsletter() {
   const key = sessionStorage.getItem("key");
    const [bios, setBios] = useState([{}]);
    const navigate = useNavigate();
    const [showDiv, setShowDiv] = useState(false);
    
     useEffect(() => {
        const endpoint = `https://biograf.ebillet.dk/systemnative/report.asmx/man_getorganizers?Key=${key}`;
        if (key) {
          fetch(endpoint, {
            method: "GET",
            headers: {
              ebilletToken: "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
            },
          })
            .then((res) => {
              if (res.status !== 200) {
                navigate("/");
              }
              return res.json();
            })
            .then((result) => {
              // console.log(result)
              setBios(result);
    
              // console.log('biograf length',result.length)
              if (result.length === 1) {
              }
              // setMovieNumber(result.map((number) => number.No));
            });
        }
      }, [key]);
  
      function handleClick () {
       setShowDiv((current => !current))
      }
  console.log(bios)
  
  return (
    <div className='sentNewsletter'> 
    
      <p className='newsletter_title'>Udsendte nyhedsbreve</p>
         <label htmlFor="" style={{fontSize:'18px',fontWeight:700,letterSpacing:'0.36px',color:'#46484c',marginBottom:'11px'}}>Biograf</label>
         <div className="movieListBox" style={{width: "384px",}}> 
     
          <span className="select-line" style={{ backgroundColor: "#8d8d8d" ,position:'absolute',right:'30px',width:'0.5px'}}></span>
        <select
                  className="form-select text-truncate"
                  value='Nyeste først'
                  style={{
                    height: "40px",
                    border: "1px solid #8d8d8d",
                    backgroundRepeat: "no-repeat",
                    color:'#46484c',
                   // backgroundColor: "#f7f7f7",
                     backgroundImage: `url(${downArrow})`,
                  }}
                >
                 {bios &&
                    bios.map((item) => {
                      let bb = item.City + " - " + item.Name + " " + item.No;
                      return (
                        <option
                          key={item.id}
                          value={bb}
                          className="text-truncate"
                          style={{
                            maxWidth:'380px',
                            marginLeft: "10px",
                            fontSize: "16px",width:'370px'
                          }}
                        >
                          {item.City} - {item.Name}
                        </option>
                      );
                    })}
                </select>
        </div>
        <div className='newsMailHeader' style={{gridTemplateColumns:'1fr 1fr 1fr 1fr 0.2fr'}}> 
          <p style={{alignContent:'center',margin:0,}}>Navn på nyhedsmail</p>
          <p style={{alignContent:'center',margin:0,}}>Segment</p>
          <p style={{alignContent:'center',margin:0,}}>Udsendelsesdato</p>
          <p style={{alignContent:'center',margin:0,}}> Tidspunkt</p>
         
          <p style={{alignContent:'center',margin:0,width:'50px'}}></p>
        </div>
        <div style={{borderBottom: showDiv === true ? '1px solid' : '',
           border: showDiv === true ? '2px solid #ccced1' : '',
          borderRadius:'2px',marginTop:'13px'}}>
         <div className='newsMailBody' style={{
           border: showDiv === false ? '1px solid #ccced1' : '',
          gridTemplateColumns:'1fr 1fr 1fr 1fr 0.3fr',borderBottom:'1px solid #ccced1'}}> 
          <p style={{alignContent:'center',margin:0,paddingLeft:'16px',height:'45px'}}>Først weekend i marts</p>
          <p style={{alignContent:'center',margin:0,width:'255px',height:'45px',}}>Operakunder</p>
          <p style={{alignContent:'center',margin:0,height:'45px'}}>01-03-2025</p>
          <p style={{alignContent:'center',margin:0,height:'45px',textAlign:'center',width:'70px'}}>11:00</p>
         
         <p onClick={handleClick} style={{textAlign:'center',lignContent:'center',cursor:'pointer',marginTop:'15px',rotate:showDiv === false ? '180deg' : ''}}><svg xmlns="http://www.w3.org/2000/svg" width="18" height="10" viewBox="0 0 18 10" fill="none">
          <path d="M0.353546 0.355469L8.85355 8.85547L17.3535 0.355469" stroke="#101010"/>
          </svg></p>
         
        </div>
        {
          showDiv === true ? <div >
              <svg style={{marginTop:'-25px'}} xmlns="http://www.w3.org/2000/svg" width="979" height="1" viewBox="0 0 979 1" fill="none">
               <path d="M0 0.5H978.5" stroke="#CCCED1"/>
            </svg>
            <div style={{paddingTop:'39px',paddingLeft:'80px',display:'flex',justifyContent:'space-between'}}>
               <div>
                <p style={{margin:0}}>Emnefelt på nyhedsmail:</p>
                <p>Saml operaveninderne i Biohuset</p>
               </div>
               
               <div style={{marginRight:'20%'}}>
                <p style={{margin:0}}>Modtagere</p>
                <p>1.331 modtagere i segmentet “Operakunder”</p>
               </div>
             </div>
             
             <div style={{display:'flex',gap:'10px',margin:'45px 60px'}}>
              <div className='mail-boxes' style={{width:'187px',padding:'16px 20px'}}>
                <p className='head'>Åbnede mails</p>
                <p className='body'>12.2%</p>
                <p className='foot'>161 åbnede</p>
                </div>
              <div className='mail-boxes' style={{width:'187px',padding:'16px 20px'}}>
                <p className='head'>Antal klik i mail</p>
                 <p className='body'>12.2%</p>
                <p className='foot'>16 klikkede</p>
                </div>
              <div className='mail-boxes' style={{width:'207px',padding:'16px 20px'}}><p className='head'>Afviste mails</p>
               <p className='body'>12.2%</p>
                <p className='foot'>11 blev afvist</p></div>
              <div className='mail-boxes' style={{width:'254px',padding:'16px 20px'}}><p className='head'>Afmeldte abonnenter</p>
                <p className='body'>0.2%</p>
                <p className='foot'>1 afmeldte sig</p>
              </div>

             </div>
              <svg style={{marginTop:'-25px'}} xmlns="http://www.w3.org/2000/svg" width="979" height="1" viewBox="0 0 979 1" fill="none">
               <path d="M0 0.5H978.5" stroke="#CCCED1"/>
            </svg>
           <div style={{display:'flex',gap:'10px',margin:'15px 60px'}}>
              <div className='mail-boxes' style={{width:'269px',padding:'16px 20px'}}>
                <p className='head'> Antal bestilte billetter</p>
                  <p className='body'>714</p>
                <p className='foot'>7.140 kr. potentielt</p>
                </div>
              <div className='mail-boxes' style={{width:'269px',padding:'16px 20px'}}> <p className='head'> Solgte billetter</p>
                  <p className='body'>714</p>
                <p className='foot'>7.140 kr. omsat</p></div>
              <div className='mail-boxes' style={{width:'298px',padding:'16px 20px'}}> 
                <p className='head'> Salg i alt</p>
                  <p className='body'>12,260 kr.</p></div>
             </div> 
             <br />
             <svg style={{marginTop:'-25px'}} xmlns="http://www.w3.org/2000/svg" width="979" height="1" viewBox="0 0 979 1" fill="none">
               <path d="M0 0.5H978.5" stroke="#CCCED1"/>
            </svg>
            <br />
           <section style={{width:'540px',margin:'auto',textAlign:'center'}}>
           
                <p className='openedMailTitel' style={{paddingTop:'8px'}}>Jeres mail</p>
                
              
                <div style={{border:'1px solid #8d8d8d',borderRadius:'4px',padding:'10px',marginTop:'18px'}}></div>
              <br />
          </section>
          </div> : null
          
        }
        </div>
    </div>
  )
}

export default SentNewsletter